<template>
  <div class="wrcIndex tc" @click="dblBtn">
    <div class="cont flex">
      <div class="item" @click.stop="toEmployee('outStock')">出库</div>
      <div class="item" @click.stop="toEmployee('inStock')">入库</div>
    </div>
    <div class="configBtnIndex" v-show="showBtn == true" @click.stop>
      <el-button type="info" @click="toEmployee('wrc')">员工生物特征录入</el-button>
      <el-button type="info" @click="toConfig">修改配置</el-button>
    </div>
    <div class="reviewBtn">
      <el-button @click="toReview">复核</el-button>
    </div>
    <currtime :isShowInfo="false" @click.stop></currtime>
    <custService></custService>
  </div>
</template>

<script>
import currtime from '../../assets/currTime'
import custService from '../../assets/custService'
import { loginApi,borrowApi } from '../../../static/js/api.js'
import { localUserInfo,checkOnLine } from '../../../static/js/utils/utility.js'
import {checkData} from '../../../static/js/utils/util.js'
import * as config from '../../../static/js/config.js';
export default {
  name: 'wrcIndex',
  data () {
    return {

      showBtn:false,
      num:0,//点击次数

      onLine:false,

    }
  },
  mounted(){
    
  },
  components:{
    currtime,
    custService
  },
  created() {
    this.onLine = this.$store.state.onLine
  },
  methods:{
    //跳转到复核清单页
    toReview(){
      // console.log('toReview',this.onLine)
      if(this.onLine == false){
        checkOnLine()
      }else{
      this.$router.push({
        path:'/toolCabinet/reView',
      })
      }
    },
    //跳转到登录页
    toEmployee(type){
      var that = this
      // if(type){
        that.$router.push({
          path: '/unmanned/wrcLogin',
          query:{
            'isType':type
          }
        })
      // }else{
      //   that.$router.push({
      //     path: '/unmanned/wrcLogin',
      //   })
      // }
    },
    //跳转到配置页
    toConfig(){
      this.$router.push({
        path:'/CConfigSetting',
        query:{
          'project':true,
        }
      })
    },
    //连续点击屏幕5次
    dblBtn(){
      var that = this;
      this.num++
      if(this.num==1){
        that.timer1=new Date().getTime()/1000
      }
      if(this.num==5){
        this.timer4= new Date().getTime()/1000
        if(that.timer4-that.timer1<=2){
          that.num=0
          that.showBtn=true
          setTimeout(function(){
            that.showBtn = false
          },5000);
        }else {
          this.num=0
        }
      }
    },
  },
  watch:{
    "$store.state.onLine":function(newVal){
      this.onLine = newVal
      // console.log('newVal',newVal)
    }
  },
}
</script>

<style lang="less">
.wrcIndex{
  box-sizing: border-box;
  .reviewBtn{
    position: absolute;
    left: 0.4rem;
    bottom: 0.2rem;
    .el-button{
      background: linear-gradient(#4aaafe, #0769be);
      font-size: 0.4rem;
      color: #fff;
      border: none;
      padding: 0 0.6rem;
      height: 0.94rem;
      line-height: 0.94rem;
      border-radius: 0.12rem;
    }
  }
  .cont{
    height: 100vh;
    justify-content: center;
    align-items: center;
    .item{
      height: 3rem;
      line-height: 3rem;
      padding: 0 2rem;
      font-size: 0.8rem;
      color: #fff;
      font-weight: bold;
      border: none;
      margin: 0 0.5rem;
      border-radius: 0.12rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .configBtnIndex{
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      // width: 2.54rem;
      padding: 0 0.6rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CUnmanned/wrcIndex.vue